import { LayerType } from "../../types";
import { ConstraintsLayerType } from "../ConstraintsLayerType";
import { PermitsLayerControlPage } from "./PermitsLayerControlPage";
import { PERMITS_LAYER_TYPE_ID } from "./constants";
import { PermitsLayerMapLayer } from "./PermitsLayerMapLayer";
import { PermitsLayerProvider } from "./Context";

export const PermitsLayerType: LayerType = {
  id: PERMITS_LAYER_TYPE_ID,
  ControlPage: PermitsLayerControlPage,
  MapLayer: PermitsLayerMapLayer,
  SelectionSidebar: ConstraintsLayerType.SelectionSidebar,
  RightClickMenu: ConstraintsLayerType.RightClickMenu,

  Provider: PermitsLayerProvider,
  clickResolver: ConstraintsLayerType.clickResolver,
};
